import React, { ButtonHTMLAttributes, FC, ReactNode } from 'react';
import { StyledButton } from './styles';

interface SecondaryButtonProps {
  styleType?: 'default' | 'color' | 'error';
  disabled?: boolean;
  children: ReactNode;
  onClick?: () => void;
  type?: ButtonHTMLAttributes<HTMLButtonElement>['type'];
}

/**
 * A secondary button component that can be styled in three different ways:
 * "default", "color", and "error". It also has a disabled state, supports
 * child elements, and can trigger an onClick event.
 *
 * @param styleType - The type of styling to apply to the button. Defaults to "default".
 * @param disabled - A boolean indicating whether the button is disabled. Defaults to false.
 * @param children - The child elements to render inside the button.
 * @param onClick - A function that is called when the button is clicked.
 * @param type - The type of HTML button element to use. Defaults to "button".
 */
const SecondaryButton: FC<SecondaryButtonProps> = ({
  styleType = 'default',
  disabled = false,
  children,
  onClick,
  type,
}) => {
  return (
    <StyledButton
      styleType={styleType}
      disabled={disabled}
      onClick={onClick}
      type={type}
    >
      {children}
    </StyledButton>
  );
};

export default SecondaryButton;
